












































import { Vue, Component } from "../vue-ext";
import { Message, HousingCompany } from "../models";

@Component
export default class MessagesView extends Vue {
    private messages: Message[] = [];
    private housingCompany: HousingCompany | null = null;
    private search: string = "";
    private page: number = 1;
    private pageSize: number = 10;
    private lastPage: number = 1;

    private async created() {
        this.root.setTitle(this.$t("menu.messages") as string);
        this.root.setIconClass("icon-tiedotteet");

        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;

        if (!this.housingCompany) {
            this.$router.push("/choose-housing-company");
        }

        this.messages = this.root.messages; // this.root.getMessages();

        this.lastPage = Math.ceil(this.messages.length / this.pageSize);
        this.page = 1;
    }

    private next() {
        if (this.page < this.lastPage) {
            this.page = this.page + 1;
        }
    }

    private previous() {
        if (this.page > 1) {
            this.page = this.page - 1;
        }
    }

    private filteredMessages() {
        let filteredMessages = this.search ? this.messages.filter(m => m.topic.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) : this.messages;
        this.lastPage = Math.ceil(filteredMessages.length / this.pageSize);

        if (this.page > this.lastPage) {
            this.page = this.lastPage;
        }

        return filteredMessages.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }
}
